// extracted by mini-css-extract-plugin
export default {"badge__new":"new_badge__badge__new--1W-o"};